import { useCallback } from 'react';
import { parseCallback, useNativeEventListener } from '@eika-infrastruktur/mobilbank-lib';
import { useSigningContext } from './signingContext';
import { Actions } from './signingTypes';
const getPaymentStatus = (payload) => {
    if (!payload)
        return 'UNKNOWN';
    try {
        return payload;
    }
    catch (_) {
        return 'UNKNOWN';
    }
};
const useSigningContextResult = (closePayment) => {
    const { dispatch, showSigningFlow } = useSigningContext();
    const onMessage = useCallback((event) => {
        if (!showSigningFlow)
            return;
        const data = parseCallback(event.data);
        if (data) {
            switch (data.action) {
                case 'BROWSER_CALLBACK_RESULT': {
                    switch (data.payload) {
                        case 'CANCEL': {
                            dispatch({ type: Actions.CANCEL });
                            break;
                        }
                        case 'ERROR': {
                            dispatch({ type: Actions.COMPLETE_SIGNING, status: 'REJECTED' });
                            break;
                        }
                        default: {
                            dispatch({
                                type: Actions.COMPLETE_SIGNING,
                                status: getPaymentStatus(data.payload),
                            });
                            break;
                        }
                    }
                    break;
                }
                case 'SIGNING_STATUS_UPDATE_PAYMENT': {
                    dispatch({ type: Actions.COMPLETE_SIGNING, status: getPaymentStatus(data.payload) });
                    break;
                }
                case 'SIGNING_CANCEL': {
                    dispatch({ type: Actions.CANCEL });
                    break;
                }
                case 'PAYMENT_CANCEL': {
                    dispatch({ type: Actions.RESET });
                    closePayment();
                    break;
                }
                case 'SIGNING_ERROR': {
                    if (data.payload === 'DYNAMIC_LINK_EXPIRED') {
                        dispatch({ type: Actions.COMPLETE_SIGNING, status: 'EXPIRED' });
                    }
                    else {
                        dispatch({ type: Actions.COMPLETE_SIGNING, status: 'REJECTED' });
                    }
                    break;
                }
                default:
                    break;
            }
        }
    }, [closePayment, dispatch, showSigningFlow]);
    useNativeEventListener(onMessage);
    return { cancelSigning: () => dispatch({ type: Actions.CANCEL_SIGNING }) };
};
export default useSigningContextResult;
//# sourceMappingURL=data:application/json;base64,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